import React from "react";
import AgencyInteriorContact from "../../components/AgencyInetriorcontact";


import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const Section1 = () => {
  return (
    <React.Fragment>
      <hr />
  
      <AgencyInteriorContact />
    
    </React.Fragment>
  );
};

export default Section1;
